// frontend/src/components/CommentsSection.jsx

import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "./CommentsSection.css";

const CommentsSection = ({
  questionId,
  comments,
  onAddComment,
  reviewerName,
  ownerName,
  onClose, // new optional prop for the 'X' button
}) => {
  // Reference to the <ul> container
  const listRef = useRef(null);

  // Scroll to bottom whenever `comments` update
  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [comments]);

  return (
    <div className="comments-section">
      <div className="comments-header">
        <h3>Comments</h3>
        {onClose && (
          <button className="close-comments-button" onClick={onClose}>
            ✕
          </button>
        )}
      </div>

      <ul className="comments-list" ref={listRef}>
        {comments.map((comment, index) => {
          // Determine if this comment is from the owner or the current user
          const isOwnerComment =
            comment.commenterName === reviewerName ||
            comment.commenterName === ownerName;

          return (
            <li
              key={index}
              className={[
                "comment-item",
                comment.isRead ? "read" : "unread",
                isOwnerComment ? "owner-comment" : ""
              ].join(" ")}
            >
              <div className="comment-header-row">
                <div className="commenter">{comment.commenterName}</div>
                <div className="comment-date">
                  {new Date(comment.createdAt).toLocaleString()}
                </div>
              </div>
              <div className="comment-text">{comment.commentText}</div>
            </li>
          );
        })}
      </ul>

      <form
        className="add-comment-form"
        onSubmit={(e) => {
          e.preventDefault();
          const input = e.target.elements.commentText;
          const text = input.value.trim();
          if (text) {
            onAddComment(questionId, text);
            input.value = "";
          }
        }}
      >
        <input
          type="text"
          name="commentText"
          placeholder="Add a comment..."
          required
        />
        <button type="submit">Add</button>
      </form>
    </div>
  );
};

CommentsSection.propTypes = {
  questionId: PropTypes.string.isRequired,
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      commenterName: PropTypes.string.isRequired,
      commentText: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      isRead: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onAddComment: PropTypes.func.isRequired,
  reviewerName: PropTypes.string,
  ownerName: PropTypes.string,
  onClose: PropTypes.func, // new prop
};

export default CommentsSection;
